import { Injectable } from '@angular/core';
import {
  Map,
  icon,
  LatLngExpression,
  Marker,
  tileLayer,
  marker,
  featureGroup,
  Layer
} from 'leaflet'
import * as lfGeo from 'leaflet.geodesic';
import { GestureHandling } from "leaflet-gesture-handling";


@Injectable({
  providedIn: 'root'
})
export class MapService {

  /**
   * Map Service is used in 2 places, the Flight Detail View and the Flight Sequence View.
   * Two differenct coord LatLng sets will be passed in independently since the 
   * Sequence View passes in dep/arr with [][] of coord and Flight Details only passes in one [] of
   * dep/arr coords.  To determine which view is making the request the isDetailView will 
   * be eiher a 0 or 1, then the map can render according the conditional stmts.
   */
  constructor() { }

  fltDetialcoords?: LatLngExpression[];
  seqDetailCoords?: LatLngExpression[][];
  map?: Map
  geoLineColor?: string;
  geoLine?: lfGeo.GeodesicLine;
  stationMarker?: Marker;
  isDetailView?: number;

  renderMap(
    isDetailView: number,
    fltDetailCoords?: LatLngExpression[], 
    seqDetailCoords?: LatLngExpression[][], 
    geoLineColor?: string
  ): Map {
    // Map.addInitHook('addHandler', 'gestureHandling', GestureHandling);
    // Map.mergeOptions({
    //   gestureHandling: true
    // });
    if(isDetailView === 0 && fltDetailCoords) {
      this.fltDetialcoords = fltDetailCoords;
      this.isDetailView = isDetailView;
      
    }
    else {
      this.seqDetailCoords = seqDetailCoords;
      this.isDetailView = isDetailView;
    }
    
    if (geoLineColor) {
      this.geoLineColor = geoLineColor;
    }
    
    return this.initMap()
  }

  initMap(): Map {
    
    if (!this.map) {
      this.map = new Map('map');
    } else {
      this.map.remove();
      this.map = new Map('map');
    }
    
    if (this.map) {
      this.map.addHandler('gestureHandling', GestureHandling);
      // @ts-expect-error typescript does not see handler.
      this.map.gestureHandling.enable();
      

      const tiles = tileLayer(
        'https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}{r}.png',
        {
          detectRetina: true,
          subdomains: 'abcd',
          attribution:
            '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>, &copy; <a href="https://carto.com/attributions">CARTO</a>',
          maxZoom: 20,
          
        }
      );
      tiles.addTo(this.map);
      
      //Add markers using coords from  Flight Detial View only
      if(this.fltDetialcoords && this.isDetailView === 0) {
        for(let coord of this.fltDetialcoords) {
          let staMarker = marker(coord, {
            icon: icon({
              iconSize: [12, 20],
              iconAnchor: [6, 20],
              iconUrl: 'assets/marker-icon-2x.png',
              iconRetinaUrl: 'assets/marker-icon-2x.png',
              shadowSize: [0, 0],
            })
          });
          staMarker.addTo(this.map);
        }
        this.geoLine = new lfGeo.GeodesicLine(this.fltDetialcoords, {
          color: this.geoLineColor,
          weight: 1.5,
          wrap: false
        }).addTo(this.map);
        this.geoLine.addTo(this.map);
        this.map.attributionControl.setPrefix('');
        this.map.fitBounds(this.geoLine.getBounds());
        
        
        return this.map
      }
      //Add markers using coords from Sequence Detial View only
      else {
        if(this.seqDetailCoords && this.isDetailView === 1) {
          let markers: Layer[] = [];
          for(let staCoords of this.seqDetailCoords) {
            staCoords.forEach( (coord) => {
              let staMarker = marker(coord, {
                icon: icon({
                  iconSize: [12, 20],
                  iconAnchor: [6, 20],
                  iconUrl: 'assets/marker-icon-2x.png',
                  iconRetinaUrl: 'assets/marker-icon-2x.png',
                  shadowSize: [0, 0],
                })
              });
              markers.push(staMarker);
            })
            featureGroup(markers).addTo(this.map);
          }
          
          this.geoLine = new lfGeo.GeodesicLine(this.seqDetailCoords, {
            color: 'blue',
            weight: 1.5,
            wrap: false
          }).addTo(this.map);
          this.geoLine.addTo(this.map);
          this.map.attributionControl.setPrefix('');
          this.map.fitBounds(this.geoLine.getBounds());

          return this.map
        }
      }
    }
    return new Map('map');
  }
}
